import { Menu, Button, Modal, Skeleton, Typography } from "antd";
import { useState, useContext, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { QuestionCircleFilled } from "@ant-design/icons";
import LogonewImg from "../../assets/images/Clip_path_logo.svg";
import moment from "moment";
import lang from "../../helper/lang";
import {
  COMMON_MODULE_KEYS,
  PERMISSION_MODULE_KEYS,
  USERTYPE,
} from "../../constants/conts";

export const menuItems = [
  {
    key: "DASHBOARD",
    path: "/admin/dashboard",
    icon: "fas fa-tachometer-alt",
    label: `${lang("Dashboard")}`,
  },

  {
    key: "SESSION_MANAGEMENT",
    label: `Session Management`,
    path: "/admin/session-manager",
    icon: "fas fa-lock",
  },

  {
    key: "ADMIN_ACCOUNT_MANAGEMENT",
    label: `Admin Account Management`,
    path: "/admin/admin-account-manager",
    icon: "fas fa-desktop",
  },

  {
    key: "USER_MANAGER",
    label: `User Manager`,
    path: "/admin/user-manager",
    icon: "fas fa-users",
  },
  {
    key: "COACH_ACADEMY_MANAGEMENT",
    label: `Coach & Academy Manager`,
    path: "/admin/coach-manager",
    icon: "fas fa-graduation-cap",
  },
  {
    key: "LEADERBOARD_MANAGER",
    path: "/admin/leaderboard-manager",
    icon: "fas fa-trophy",
    label: `Leaderboard Manager`,
  },
  {
    key: "TOURNAMENT_MANAGER",
    path: "/admin/tournaments",
    icon: "fas fa-medal",
    label: `Tournament Manager`,
  },

  {
    key: "CLIP_TYPE_MANAGER",
    path: "/admin/clip-type-manager",
    icon: "fas fa-tags",
    label: `Clip Type Manager`,
  },

  {
    key: "TAG_MANAGER",
    path: "/admin/tag-manager",
    icon: "fas fa-tags",
    label: `${lang("Tag Manager")}`,
  },
  {
    key: "ROLE_MANAGER",
    path: "/admin/role-manager",
    icon: "fas fa-shield-alt",
    label: `Role Manager`,
  },
  {
    key: "POINTS_LEVELS_MANAGER",
    path: "/admin/point-manager",
    icon: "fas fa-coins",
    label: `Point Manager`,
  },
  {
    key: "LEVELS_MANAGER",
    path: "/admin/level-manager",
    icon: "fas fa-signal",
    label: `Level Manager`,
  },
  {
    key: "BADGE_MANAGER",
    path: "/admin/badge-manager",
    icon: "fas fa-star",
    label: `Badge Manager`,
  },
  {
    key: "REWARDS_MANAGER",
    path: "/admin/reward-manager",
    icon: "fas fa-medal",
    label: `Reward Manager`,
  },
  {
    key: "REDEMPTION_MANAGER",
    path: "/admin/redemption-manager",
    icon: "fas fa-check-circle",
    label: `Redemption Manager`,
  },
  {
    key: "POST_MANAGER",
    path: "/admin/post-manager",
    icon: "fas fa-heart",
    label: `Post Manager`,
  },
  {
    key: "GROUP_MANAGER",
    path: "/admin/group-manager",
    icon: "fas fa-users",
    label: `Group Manager`,
  },
  {
    key: "MUSIC_MANAGER",
    path: "/admin/music-manager",
    icon: "fas fa-music",
    label: "Music Manager",
  },
  {
    key: "REPORT_MANAGER",
    path: "/admin/report-manager",
    icon: "fa fa-bug",
    label: `${lang("Report")} ${lang("Manager")}`,
  },

  {
    key: "EMAIL_TEMPLATE_MANAGER",
    path: "/email-template",
    icon: "fas fa-envelope",
    label: `${lang("Email_Template")} ${lang("Manager")}`,
  },
  {
    key: "NOTIFICATION_MANAGER",
    path: "/admin/notification-manager",
    icon: "fas fa-bell",
    label: `${lang("Notification")} ${lang("Manager")}`,
  },
  {
    key: "INTEGRATION_MANAGER",
    path: "/admin/integration-manager",
    icon: "fas fa-plug",
    label: `API & Integration Manager`,
  },
  {
    key: "MAINTENANCE_MANAGER",
    path: "/admin/maintenance-manager",
    icon: "fas fa-wrench",
    label: `Maintenance Manager`,
  },
  {
    key: "POLICY_MANAGER",
    path: "/admin/policy-manager",
    icon: "fas fa-file-contract",
    label: "App Policies",
  },

];

function Sidenav({ color }) {
  const { pathname } = useLocation();
  const page = pathname.replace("/", "");
  const { userProfile, logout, setUserProfile } = useContext(AuthContext);
  const { confirm } = Modal;
  const [collapsed, setCollapsed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [menuLinks, setMenuLinks] = useState([]);
  const [menuMode, setMenuMode] = useState("vertical");
  const [currentDateTime, setCurrentDateTime] = useState(moment());

  const showDeleteConfirm = (record) => {
    setTimeout(() => {
      confirm({
        okText: lang("Logout"),
        okType: "danger",
        icon: <QuestionCircleFilled />,
        cancelText: lang("Cancel"),
        content: (
          <Button>
            {" "}
            {lang("Are_you_sure_you_want_to")} {lang("Logout")} ?
          </Button>
        ),
        onOk() {
          logout();
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    }, 5);
  };

  const renderTitle = (item) => {
    return (
      <>
        <span className="icon">
          <i className={item.icon}></i>
        </span>
        <span className="label">{item.label}</span>
      </>
    );
  };

  useEffect(() => {
    console.log("Enter in sideNav use effect");
    console.log("user profiles===>", userProfile);

    if (!userProfile) return;

    // 🔥 SUPER ADMIN → ALL ACCESS
    if (userProfile.role === USERTYPE.SUPER_ADMIN) {
      setMenuLinks(menuItems);
      setLoading(false);
      return;
    }

    // 🟢 COMMON MENUS → ALWAYS VISIBLE
    const commonMenus = menuItems.filter((item) =>
      COMMON_MODULE_KEYS.includes(item.key),
    );

    // 🔐 PERMISSION-BASED MENUS
    const permissionMenus = menuItems.filter(
      (item) =>
        PERMISSION_MODULE_KEYS.includes(item.key) &&
        userProfile.permissions?.[item.key]?.enabled === true,
    );

    setMenuLinks([...commonMenus, ...permissionMenus]);
    setLoading(false);
  }, [userProfile]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setMenuMode("inline");
      } else {
        setMenuMode("vertical");
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const updateDateTime = () => {
      setCurrentDateTime(moment());
    };
    const intervalId = setInterval(updateDateTime, 1000);
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <>
      <div className="brand-logo text-center">
        <NavLink to="/" className="imgOuter">
          {/* <Title className="mt-2">CrikClip</Title> */}
          <img src={LogonewImg} alt="Logo" />
        </NavLink>
      </div>

      {loading ? (
        [1, 2, 3, 4, 5, 6].map((item) => <Skeleton active key={item} />)
      ) : (
        <Menu inlineCollapsed={false} mode={menuMode} className="sideNavMain">
          {menuLinks.map((item) => {
            if (item.children) {
              return (
                <Menu.SubMenu
                  key={item.key}
                  title={
                    <>
                      <span className="icon">
                        <i className={item.icon}></i>
                      </span>
                      <span className="label">{item.label}</span>
                    </>
                  }
                >
                  {item.children.map((child) => (
                    <Menu.Item key={child.key}>
                      <NavLink to={child.path}>{child.label}</NavLink>
                    </Menu.Item>
                  ))}
                </Menu.SubMenu>
              );
            }

            return (
              <Menu.Item key={item.key}>
                <NavLink to={item.path}>{renderTitle(item)}</NavLink>
              </Menu.Item>
            );
          })}

          <Menu.Item>
            <a onClick={showDeleteConfirm}>
              <>
                <span className="icon">
                  <i className="fas fa-sign-out-alt"></i>
                </span>
                <span className="label"> {lang("Logout")} </span>
              </>
            </a>
          </Menu.Item>
        </Menu>
      )}
    </>
  );
}

export default Sidenav;
